// import { useAuth0 } from "../yoello-lib/modules/auth/Auth0";
import * as Sentry from "@sentry/browser";
import { useAuthenticationContext } from "../yoello-lib/modules/auth/AuthenticationContext";

export function useSentry() {
    // const { user } = useAuth0()!;
    const { currentUser } = useAuthenticationContext();

    function captureException(error: Error, feature?: string, dataObject?: any) {
        // const loggedUser = user as auth0.Auth0UserProfile;
        Sentry.captureException(error, (scope) => {
            if (currentUser) {
                scope.setUser({
                    username: currentUser.username || currentUser.name,
                    email: currentUser.email
                });
            }
            if (dataObject) {
                scope.setTag("dataobject", JSON.stringify(dataObject));
            }
            if (feature) {
                scope.setTag("feature", feature);
            }
            return scope;
        })
    }

    return {
        captureException
    }
}